import { render, staticRenderFns } from "./ListSummaryWebpart.vue?vue&type=template&id=b0a79798"
import script from "./ListSummaryWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ListSummaryWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports